import { render, staticRenderFns } from "./PosicionamentoAssinatura.vue?vue&type=template&id=7d55b7f2"
import script from "./PosicionamentoAssinatura.vue?vue&type=script&lang=js"
export * from "./PosicionamentoAssinatura.vue?vue&type=script&lang=js"
import style0 from "./PosicionamentoAssinatura.vue?vue&type=style&index=0&id=7d55b7f2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports